import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=5e537306&"
var script = {}
import style0 from "./Whatsapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports